import React, { Component } from 'react';
import JSZip from 'jszip';
import JSZipUtils from 'jszip-utils';
import Docxtemplater from 'docxtemplater';
import { saveAs } from 'file-saver';
import { connect } from 'react-redux';
import localforage from 'localforage';
import Card from 'material-ui/Card';
import IconButton from 'material-ui/IconButton';
import Download from 'material-ui/svg-icons/file/file-download';

import { currency } from '../services/services';


const styles = {
  card: {
    position: 'relative',
    margin: 'auto',
    bottom: 0,
    display: 'flex',
    marginTop: '30px',
  },
  details: {
    display: 'flex',
    flexDirection: 'column',
  },
  content: {
    flex: '1 0 auto',
  },
  cover: {
    width: 151,
    height: 151,
  },
  controls: {
    display: 'flex',
    alignItems: 'center',
    paddingLeft: '5px',
    paddingBottom: '5px',
  },
  largeIcon: {
    width: '91px',
    height: '91px',
    'padding-top': '2px!important',
  },
  largeButton: {
    width: 100,
    height: 60,
    'padding-top': 20,
  },
  divStyle:{
    /*'border-top': '1px solid #222',
    'border-bottom': '1px solid #222',
    'border-left': '1px solid #222',
    'border-right': '1px solid #222',*/
    'margin-bottom': '10px',
    display: 'inline-block',
    'padding-right': '15px',
},
}


class DocxGenerator extends Component {
  //<ToolbarGroup firstChild={true}>
    //<input id="rawFile" style={{ marginLeft: '20px' }} type="file" />
    //<RaisedButton label="eigene Vorlage" onClick={() => { getDocxLocal(this.props.feeCalculation); }} />
  //</ToolbarGroup>
  render() {
    return (
      <div>
        <Card style={styles.card}>
          <h3 style={{
              'text-align': 'center;',
              'marginLeft': '30px',

            }}>Anwaltskostenberechnung in Word exportieren</h3>
          <div style={styles.divStyle}>
            <a
              onClick={() => { getDocxFromUrl(this.props.feeCalculation); }}
              stlye={{margin:'auto'}}
              >


              <IconButton  tooltip= "Erstellt eine .Docx für Word mit Ihrer RVG-Berechnung" touch={true} tooltipPosition="top-right"
                iconStyle={styles.largeIcon}
                style={styles.largeButton}
              >
                <Download />
              </IconButton>
                .docx herunterladen
            </a>
          </div>

        </Card>
      </div>
    );
  }
}


function getLocalForageKeys(callback) {
  configLocalForage();
  localforage.keys()
    .then(callback)
    .catch(function(err) {
    // This code runs if there were any errors
      console.log(err);
  });
}

function saveLocally(data, fileName) {
  configLocalForage();
  console.log(localforage.supports(localforage.INDEXEDDB));
  //debugger;
  localforage.setItem(fileName, data).then(() => {
    console.log('success - file locally safed');
  }).catch(function (e) {
    console.log('error beim speicher von blob' + e);
  });
}
function loadLocallyWithLocalForage() {
  configLocalForage();
  localforage.getItem('key').then(() => {
    console.log('success - file locally loaded');
  }).catch(() => {
    console.log('error beim laden von blob');
  });
}
function configLocalForage() {
  localforage.config({
    // driver: localforage.WEBSQL, // Force WebSQL; same as using setDriver()
    name: 'rvg',
    size: 2980736, // Size of database, in bytes. WebSQL-only for now.
    storeName: 'docx', // Should be alphanumeric, with underscores.
    description: 'some description',
  });
}
function calculateSum(feeCalculation) {
  const sumFunc = (acc, elem) => {
    if(isFinite(elem.sum) && elem.sum !== '') { return acc + parseFloat(elem.sum);
  } return acc;
};
let sum = feeCalculation.feeMattersExtraJudicial.reduce(sumFunc, 0) * feeCalculation.extraJudicialIsActive;
sum = (feeCalculation.judicialIsActive) ? feeCalculation.feeMattersJudicial.reduce(sumFunc, sum) : sum;
return sum;
}

function generateDocx(content, feeCalculation) {
  const zip = new JSZip(content);
  const doc = new Docxtemplater().loadZip(zip);

  //außergerichtlich
  const gebühren = [];
  const addGebühren = (feeArray) => {
    feeArray.forEach((gebühr) => {
      const docGebühr = {
        ziff: gebühr.ziff,
        Bezeichnung: gebühr.kommentar,
        Faktor: gebühr.isSetted ? gebühr.isSetted.toLocaleString() : 0,
        Summe: ((!isNaN(gebühr.sum) || (!gebühr.sum))) ? currency(gebühr.sum) : 0,
      };
      if (gebühr.sum) { gebühren.push(docGebühr); }
    });
  };
  if (feeCalculation.extraJudicialIsActive) {
    addGebühren(feeCalculation.feeMattersExtraJudicial);
  }
  if (feeCalculation.judicialIsActive) {
    addGebühren(feeCalculation.feeMattersJudicial);
  }
  const nettobetrag = currency(calculateSum(feeCalculation));
  const mwstSum = currency((feeCalculation.valueAddedTax / 100)
                  * calculateSum(feeCalculation));
  const bruttobetrag = currency(calculateSum(feeCalculation)
                      + ((feeCalculation.valueAddedTax / 100)
                      * calculateSum(feeCalculation)));
  const gegenstandswert = currency(feeCalculation.matterValue);
  doc.setData({
    Gegenstandswert: gegenstandswert,
    Gebühren: gebühren,
    Nettobetrag: nettobetrag,
    VAT: feeCalculation.valueAddedTax,
    MWST: mwstSum,
    Bruttobetrag: bruttobetrag,
    description: 'RVG-Rechner ',
  });

  try {
    // render the document (replace all occurences of {first_name} by John, {last_name} by Doe, ...)
    doc.render();
  }
  catch (error) {
    let e = {
      message: error.message,
      name: error.name,
      stack: error.stack,
      properties: error.properties,
    };
    console.log(JSON.stringify({ error: e }));
    // The error thrown here contains additional information when logged with JSON.stringify (it contains a property object).
    throw error;
  }
  var out = doc.getZip().generate({
    type: 'blob',
    mimeType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  }); //Output the document using Data-URI

  saveAs(out, 'RVG-Rechnung.docx');
}

function  getDocxFromUrl(feeCalculation) {
  JSZipUtils.getBinaryContent('.\\static\\media\\docx\\rvg-rechnung.docx', function(error, content) {
    if (error) { throw error; }
    generateDocx(content, feeCalculation);
  });
}

function getDocxLocal(feeCalculation) {
  // fileInput is an HTMLInputElement: <input type='file' id='myfileinput' multiple>
  const fileInput = document.getElementById('rawFile');

  // files is a FileList object (similar to NodeList)
  const files = fileInput.files;

  // object for allowed media types
  const accept = {
    binary: ['image/png', 'image/jpeg'],
    text: ['text/plain', 'text/css', 'application/xml', 'text/html'],
  };

  let file;
  for (var i = 0; i < files.length; i++) {
    file = files[i];
    const fileName = file.name;

    // if file type could be detected
    if (file !== null) {
      if (accept.text.indexOf(file.type) > -1) {
        // file is of type text, which we accept
        const data = file.getAsText();
        // modify data with string methods
      }
      else {
        var fileReader = new FileReader();
        fileReader.onload = () => {
          saveLocally(fileReader.result, fileName);
          generateDocx(fileReader.result, feeCalculation);
        };
        fileReader.readAsArrayBuffer(file);
      }
    }
  }
}

function mapStateToProps(state) {
  return {
    feeCalculation: state.feeCalculation,
  };
}
export default connect(mapStateToProps)(DocxGenerator);



// WEBPACK FOOTER //
// ./src/containers/docxGenerator.jsx